var _a;
import { EPropertyMemberTypes, } from "@rentiohq/shared/dist/types/property.types";
import { generateHooks } from "../generators/generator.hooks";
import { BASE_PATH_ENTITY, GENERATOR_PARAMS } from "./property.constants";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), usePaged = _a.usePaged, useUpdate = _a.useUpdate, useCount = _a.useCount, useInfiniteLoad = _a.useInfiniteLoad, useGetAll = _a.useGetAll;
export var useUpdateOwnerships = function (_a) {
    var id = _a.id;
    var updateMembers = useUpdate({ id: id }).updateMembers;
    var updateOwnerships = function (_a) {
        var ownersToAdd = _a.ownersToAdd, ownersToRemove = _a.ownersToRemove, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
        updateMembers({
            customUpdateMembersKey: "ownerships",
            customUpdateMembersPath: BASE_PATH_ENTITY + "/" + id + "/ownerships",
            membersToAdd: ownersToAdd.map(function (owner) {
                owner.roles = [EPropertyMemberTypes.Owner];
                return owner;
            }),
            membersToRemove: ownersToRemove.map(function (owner) {
                owner.roles = [EPropertyMemberTypes.Owner];
                return owner;
            }),
            onSuccess: onSuccess,
            onFailure: onFailure,
        });
    };
    return { updateOwnerships: updateOwnerships };
};
